import { render, staticRenderFns } from "./NoteCard.vue?vue&type=template&id=923a55b4&"
import script from "./NoteCard.vue?vue&type=script&lang=js&"
export * from "./NoteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports